define('models/go_order_menu',['require','backbone'],function (require) {
    var Backbone = require("backbone");
  
    return Backbone.Model.extend({
      url: function () {
        // set the endpoint for restful api for articles
        return this.id ? (App.Config.apiBase + "go-orders/products/" + this.id + "/"): 
          (App.Config.apiBase + "go-orders/products/");
      },
  
      defaults: function () {
        return { products: [] };
      },
    });
  });
  
